import { TextField } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText/FormHelperText";
import { FC } from "react";
import { ProposalActions } from "../../libs/daoService";
import { seeIfValidAddress } from "../NewProposal";
import {
  CustomMessageFields,
  CustomMessageParams,
  RequiredError,
  validateCustomMessageParams,
} from "./NoneActionFields";

export interface SendTonActionProps extends CustomMessageParams {
  kind: ProposalActions.sendTon;
  address: string;
  tonAmount: string;
  comment?: string;
}

export const validateSendTonActionParams = async (
  action: Partial<SendTonActionProps>
): Promise<Partial<SendTonActionProps>> => {
  const value: Partial<SendTonActionProps> = { kind: action.kind };

  if (!seeIfValidAddress(action.address)) {
    Object.assign(value, { address: "Invalid Address" });
  }

  if (!action.tonAmount) {
    Object.assign(value, { jettonAmount: RequiredError });
  }

  Object.assign(value, validateCustomMessageParams(action));

  return value;
};

export const SendTonAction: FC<{
  params: Partial<SendTonActionProps>;
  setParams: (value: Partial<SendTonActionProps>) => void;
  disabled: boolean;
  submitted: boolean;
  validation: Partial<SendTonActionProps> | undefined;
}> = ({ params, setParams, disabled, submitted, validation }) => {
  return (
    <>
      <div>
        <FormHelperText sx={{ mx: "12px" }}>Wallet Address</FormHelperText>
        <TextField
          fullWidth
          value={params.address}
          disabled={disabled}
          onChange={(e) => setParams({ address: e.target.value })}
          error={submitted && validation?.address != null}
          helperText={submitted && validation?.address}
        />
      </div>

      <div>
        <FormHelperText sx={{ mx: "12px" }}>Amount</FormHelperText>
        <TextField
          fullWidth
          type="number"
          value={params.tonAmount}
          disabled={disabled}
          onChange={(e) => setParams({ tonAmount: e.target.value })}
          error={submitted && validation?.tonAmount != null}
          helperText={submitted && validation?.tonAmount}
        />
      </div>

      <div>
        <FormHelperText sx={{ mx: "12px" }}>Comment</FormHelperText>
        <TextField
          fullWidth
          value={params.comment}
          disabled={disabled}
          onChange={(e) => setParams({ comment: e.target.value })}
          error={submitted && validation?.comment != null}
          helperText={submitted && validation?.comment}
        />
      </div>

      <CustomMessageFields
        params={params}
        setParams={setParams}
        disabled={disabled}
        submitted={submitted}
        validation={validation}
      />
    </>
  );
};
